export default "__VITE_ASSET__Dt60Wd_G__"